export const priorities = ['No Priority', 'Low', 'Medium', 'High', 'Urgent'];
